import { render, staticRenderFns } from "./header-teacher.vue?vue&type=template&id=9f6b4a64"
import script from "./header-teacher.vue?vue&type=script&lang=js"
export * from "./header-teacher.vue?vue&type=script&lang=js"
import style0 from "./header-teacher.vue?vue&type=style&index=0&id=9f6b4a64&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports